import { Box } from "@mui/material";
import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React from "react";

const StoreButtons = (props) => {
  const { androidLink, iosLink } = props;

  return (
    <Box
      sx={{
        "& a:hover": {
          backgroundColor: "inherit",
        },
        "& a.fr-btn--tertiary": {
          boxShadow: "inherit",
        },
      }}
    >
      <Link button type="button" className="fr-btn fr-btn--tertiary" url={androidLink} sx={{ paddingLeft: "0" }}>
        <img src="/google-play-badge.svg" />
      </Link>
      <Link button type="button" className="fr-btn fr-btn--tertiary" url={iosLink}>
        <img src="/badges-app-store.svg" />
      </Link>
    </Box>
  );
};

StoreButtons.propTypes = {
  androidLink: PropTypes.string,
  iosLink: PropTypes.string,
};

export default StoreButtons;
